module.exports = __webpack_public_path__ + "img/tile-onionskins-desktop_cn.dc7df53.jpg";